import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    FIRST: {
        id: 'disbursementsPanel.first',
        defaultMessage: 'First disbursement date',
    },
    NEXT: {
        id: 'disbursementsPanel.next',
        defaultMessage: 'Next disbursement date',
    },
    DISBURSEMENT_DATE: {
        id: 'disbursementsPanel.disbursementDate',
        defaultMessage: 'Disbursement date',
    },
});

export default enumMessages;
